import React, { useState } from 'react';
import Modal from '../ui/Modal';
import { resolvePublicFileUrl } from '../../utils/imageUrls';

export interface PerformanceSheetImageProps {
  url: string | null | undefined;
  alt: string;
  /** Compact thumbnail for lists. */
  size?: 'sm' | 'md';
  className?: string;
}

/**
 * Result photo attached to a performance or dyno record (dyno graph, timeslip).
 * Thumbnail opens a larger view. Does not invent missing media.
 */
export const PerformanceSheetImage: React.FC<PerformanceSheetImageProps> = ({
  url,
  alt,
  size = 'sm',
  className = '',
}) => {
  const [open, setOpen] = useState(false);
  const resolved = resolvePublicFileUrl(url);
  if (!resolved) return null;

  const box = size === 'md' ? 'h-24 w-24' : 'h-16 w-16';

  return (
    <div className={className}>
      <button
        type="button"
        onClick={() => setOpen(true)}
        className={`${box} overflow-hidden rounded-md border border-white/[0.08] bg-[#111] focus:outline-none focus-visible:ring-2 focus-visible:ring-orange-500`}
        aria-label={`View ${alt}`}
      >
        <img src={resolved} alt="" className="h-full w-full object-cover" />
      </button>
      <Modal isOpen={open} onClose={() => setOpen(false)} title={alt} size="lg">
        <img src={resolved} alt={alt} className="w-full h-auto rounded-lg" />
      </Modal>
    </div>
  );
};

export default PerformanceSheetImage;
